import { Navigate, useLocation, Outlet } from 'react-router-dom';


export const RequireAuth = () => {
    const userAccessToken = localStorage.getItem('accessToken');
    const email = localStorage.getItem('email');
    const uid = localStorage.getItem('uid');
    const isAuth = !userAccessToken && !email && !uid;
    const location = useLocation();

    if (isAuth) {
        return <Navigate to="/login" state={{ from: location }} />;
    }

    return <Outlet />;
};
